import { CalendarOutlined, ExclamationCircleOutlined, PlusOutlined, TeamOutlined } from '@ant-design/icons';
import { Col, Modal, Row, Select, Spin, Tag, Tooltip } from 'antd';
import React, { createRef, FC, Fragment } from 'react';
import Board from 'react-trello';
import { Subscription } from 'rxjs';
import plansImage from '../../../assets/images/plans-modal.svg';
import { CandidateCard } from '../../../components/dashboard/candidates/candidate-board-card';
import CandidateViewModal from '../../../components/dashboard/candidates/candidate-view-modal';
import { JobOfferModalForm } from '../../../components/dashboard/forms/job-offer-modal-form';
import { JobRejectionModalForm } from '../../../components/dashboard/forms/job-rejection-modal-form';
import { InterviewSlotFormModal } from '../../../components/dashboard/interview-slot-form-modal';
import InterviewSlotsViewModal from '../../../components/dashboard/interview-slots-view-modal';
import JobOfferViewModal from '../../../components/dashboard/job-offer-view-modal';
import { RecommendCandidateModal } from '../../../components/dashboard/recommend-candidate-modal';
import { SectionTitle, TASelect } from '../../../components/dashboard/styles';
import { PackagesBox } from '../../../components/payment/packages-box/packages-box';
import TAProgressBar from '../../../components/ta-progress-bar/ta-progress-bar';
import { ButtonType, TAButton } from '../../../components/widgets';
import { ErrorCodes } from '../../../config/error-codes';
import colorsList from '../../../constants/colors-list';
import { JobStatusMap } from '../../../constants/job-status';
import RejectionReasons from '../../../constants/rejection-reasons';
import { JobApplicationStateMachine } from '../../../containers/dashboard/candidates/constants';
import { withRouter } from '../../../hooks/with-router.hook';
import companyService from '../../../services/company.service';
import jobsService from '../../../services/jobs.service';
import {
	JobApplicationCompanyReviewState,
	JobApplicationState,
	JobApplicationStep
} from '../../../types/job-application';
import { JobOfferStatus } from '../../../types/offer';
import configService from '../../../utils/config';
import { notifyError, notifySuccess } from '../../../utils/notification';
import { objToSearchFilter } from '../../../utils/obj-to-search-filter';
import { objectToSearchParams } from '../../../utils/object-to-searchparams';
import { cleanUndefined } from '../../../utils/objects';
import { createStepsStatus } from '../../../utils/steps-status';
import { camelCaseToWord } from '../../../utils/strings';
import './styles.css';
import { verificationMapper } from '../../../utils/verification-mapper';
import { OutsourcingModal } from '../../../components';
import { useTheme } from 'styled-components';
const { Option } = Select;

const applicationStateToStepMapper = {
	[JobApplicationState.APPLICATION_REVIEW]: JobApplicationStep.APPLICATION_REVIEW,
	[JobApplicationState.INTERESTED]: JobApplicationStep.COMPANY_REVIEW,
	[JobApplicationState.TO_INTERVIEW]: JobApplicationStep.INTERVIEW,
	[JobApplicationState.OFFER]: JobApplicationStep.OFFER
};

//TODO: should be refactored
const boardStyle = {
	backgroundColor: '#e9e9e9',
	maxHeight: '100%'
};
const laneStyle = { backgroundColor: '#e0e0e0', maxHeight: '67vh', overflow: 'auto' };

const JobBoardHOC: FC = () => {
	const theme = useTheme();

	return <JobBoard theme={theme} />;
};
class JobBoard extends React.Component<any, any> {
	state: any = {
		data: [],
		loading: false,
		selectedJob: null,
		jobs: [],
		companies: [],
		display: [],
		stat: null,
		showOfferForm: false,
		showRejectionForm: false,
		showCandidateView: false,
		applicationToOffer: null,
		applicationToReject: null,
		selectedApplication: null,
		selectedCard: null,
		selectedCompany: null,
		showCandidateFormModal: false,
		selectedJobSlots: null,
		plansModalVisible: false,
		slotFormModalVisible: false,
		slotsViewModalVisible: false,
		// addReportModalVisible: false,
		editApplicationModalVisible: false,
		outsourceModalVisible: false,
		addSlotsButtonAnimation: false,
		upgradeButtonAnimation: false,
		showOfferView: false,
		addSlotsButtonAnimationDuration: '10',
		upgradeButtonAnimationDuration: '10',
		jobsFilter: {},
		companiesFilter: {}
	};
	boardEventBus;

	applicationStateMachine = {
		toInterview: (card, srcLane, srcPos, dstPos) => {
			const stepsStatus = createStepsStatus(JobApplicationStep.INTERVIEW);
			if (this.props.backOffice) {
				this.changeApplicationState(
					card,
					srcLane,
					JobApplicationState.TO_INTERVIEW,
					srcPos,
					JobApplicationStep.INTERVIEW,
					stepsStatus
				);
				return true;
			}
			if (!this.state.stat.permitted) {
				this.setState({
					upgradeButtonAnimation: true
				});
				//TODO refactor this
				setTimeout(() => {
					this.setState({ upgradeButtonAnimation: false });
				}, +this.state.upgradeButtonAnimationDuration * 1000);
				notifyError("Company doesn't have enough interview permissions");
				return false;
			}
			this.showInterviewConfirmation(
				() => {
					this.changeApplicationState(
						card,
						srcLane,
						JobApplicationState.TO_INTERVIEW,
						srcPos,
						JobApplicationStep.INTERVIEW,
						stepsStatus
					);

					this.setState({
						outsourceModalVisible: true
					});
				},
				() =>
					this.boardEventBus.publish({
						type: 'MOVE_CARD',
						fromLaneId: 'toInterview',
						toLaneId: srcLane,
						cardId: card.id,
						index: srcPos
					})
			);
			return true;
		},
		offer: (card, srcLane, srcPos, dstPos) => {
			this.setState({
				showOfferForm: true,
				applicationToOffer: card
					? {
							id: card.id,
							name: card.candidate.code,
							from: srcLane,
							to: 'offer',
							index: srcPos
					  }
					: null
			});
			return true;
		},
		rejected: (card, srcLane, srcPos, dstPos) => {
			this.setState({
				showRejectionForm: true,
				applicationToReject: card
					? {
							id: card.id,
							name: card.candidate.code,
							from: srcLane,
							to: 'rejected',
							index: srcPos
					  }
					: null
			});
			return true;
		}
	};

	jobSelector = createRef<any>();

	fetchJobs = async params => {
		return await jobsService.getJobs(params, null, true);
	};

	fetchCompanies = async params => {
		return await companyService.getCompanies(params);
	};

	searchJobs$ = companyService.getPaginatedListFetcher({
		fetcher: v =>
			this.fetchJobs({
				filter: v && v['filter'] ? objToSearchFilter(v['filter']) : null,
				pageSize: configService.defaultPageSize,
				page: v && v['page'] ? v['page'] : null
			}),
		debounce: 700,
		distinct: true,
		beforeFetch: v => this.setState({ jobsFilter: v && v['filter'] ? v['filter'] : {} })
	});

	searchCompanies$ = companyService.getPaginatedListFetcher({
		fetcher: v =>
			this.fetchCompanies({
				filter:
					v && v['filter']
						? objToSearchFilter({ ...v['filter'], joinStatus: 'verified' })
						: objToSearchFilter({ joinStatus: 'verified' }),
				pageSize: configService.defaultPageSize
			}),
		debounce: 700,
		distinct: true,
		beforeFetch: v =>
			this.setState({
				companiesFilter:
					v && v['filter'] ? { ...v['filter'], joinStatus: 'verified' } : { joinStatus: 'verified' }
			})
	});

	subsribtions = new Subscription();

	async componentDidMount() {
		this.setState({ loading: true });
		if (this.props.backOffice) {
			this.subsribtions.add(
				this.searchCompanies$.subscribe(({ data: companies }) =>
					this.setState({
						loading: false,
						companies
					})
				)
			);
		}
		this.subsribtions.add(
			this.searchJobs$.subscribe(({ data: jobs }) =>
				this.setState({
					loading: false,
					jobs
				})
			)
		);
		let jobs, stat, companies, slots;
		try {
			[{ data: jobs }, stat, companies] = await Promise.all([
				jobsService.getJobs(null, null, true),
				!this.props.backOffice ? companyService.getCompanyPermissionsStat() : Promise.resolve(undefined),
				this.props.backOffice
					? companyService.getCompanies({ filter: objToSearchFilter({ joinStatus: 'verified' }) })
					: Promise.resolve(undefined)
			]);

			if (!jobs || (!this.props.backOffice && !stat) || (this.props.backOffice && !companies))
				throw new Error('Error while fetching data, Please try again later.');
		} catch (e: any) {
			notifyError(e.message);
			return;
		}
		this.setState({
			jobs,
			slots,
			stat: !this.props.backOffice && stat,
			companies: this.props.backOffice && companies.data,
			loading: false
		});
		this.jobSelector.current && this.jobSelector.current.focus();
		const { location } = this.props;

		if (location && location.search) {
			const qs = new URLSearchParams(location.search);
			const jobId = qs.get('job');
			const companyId = qs.get('companyId');
			const companyName = qs.get('name');
			const applicantId = qs.get('applicant');
			if (companyName) this.handleCompanySearch(companyName);
			if (companyId) this.handleCompanySelect(companyId);

			if (jobId) {
				const data: any = await this.selectJob(jobId);

				if (applicantId) {
					const lane = data.lanes.find(lane => lane.cards.find(c => c.application.id === applicantId));
					if (!lane) return false;
					const selectedCard = lane.cards.find(card => card.application.id === applicantId);
					if (selectedCard) {
						this.setState({
							selectedCard,
							showCandidateView: true
						});
					}
				}
			}
		}
	}
	componentWillUnmount() {
		this.subsribtions.unsubscribe();
	}
	componentWillReceiveProps = async nextProps => {
		const { location } = nextProps;
		const qs = new URLSearchParams(location.search);
		if (location.search !== this.props.location.search) {
			if (location.search) {
				let jobId = qs.get('job');
				const applicantId = qs.get('applicant');
				if (jobId) {
					await this.selectJob(jobId);
				}

				if (this.state.data.lanes.length && applicantId) {
					const lane = this.state.data.lanes.find(lane =>
						lane.cards.find(c => c.applicantId === applicantId)
					);
					if (!lane) return false;
					const selectedCard = lane.cards.find(card => card.applicantId === applicantId);
					if (selectedCard) {
						this.setState({
							selectedCard,
							showCandidateView: true
						});
					}
				}
				return;
			}

			await this.selectJob(null);
		}

		if (location.search) {
			const status = qs.get('paymentStatus');
			if (status) {
				window.location.replace(new URL(window.location.toString()).pathname);
			}
		}
	};

	onCardRemove = async applicant => {
		try {
			const resp: any = await jobsService.removeApplicant(applicant.id);
			if (!resp || !resp.success) throw new Error('Some thing went wrong');
		} catch (e: any) {
			notifyError(e.message);
			return;
		}
		this.boardEventBus.publish({ type: 'REMOVE_CARD', laneId: 'interested', cardId: applicant.id });
	};

	onEditApplication = application => {
		this.setState({ selectedApplication: application, editApplicationModalVisible: true });
	};
	onShowOffer = (offer, application) => {
		this.setState({
			showOfferView: true,
			selectedOffer: { ...offer, candidate: application.candidate },
			selectedApplication: application
		});
	};

	selectJob = async (val: any = null) => {
		if (!val) return this.setState({ selectedJob: null, selectedJobSlots: null });
		this.setState({ loading: true });
		try {
			const [job, applications, slots] = await Promise.all([
				jobsService.getJob(val),
				jobsService.getJobApplications(val),
				jobsService.getInterviewSlotsOfJob(val).catch(e => {
					notifyError("Couldn't fetch the job interview slots");
					throw new Error("Couldn't fetch the job interview slots");
				})
			]);
			if (!applications) {
				throw new Error('Error occured!, Please try again later.');
			}
			if (job && JSON.stringify(this.state.selectedJob) !== JSON.stringify(job)) {
				const data = Object.keys(JobApplicationStateMachine).reduce((obj, state) => {
					obj[state] = {
						id: state,
						title: camelCaseToWord(state),
						cards: []
					};
					return obj;
				}, {});

				applications.forEach(app => {
					const card = {
						id: app.id,
						title: app.candidate.code,
						subtitle: app.candidate.title,
						candidate: app.candidate,
						application: app,
						state: app.state,
						isRejectedMailSent: app.isRejectedMailSent,
						labels: app.labels,
						tagTooltip: 'Rejection Reason',
						bgColor: '#4ADCAA',
						currentSalary: app.currentSalary,
						expectedSalary: app.expectedSalary,
						noticePeriod: app.noticePeriod,
						colorsList,
						avatar: !!this.props.backOffice,
						onLabelDelete: this.removeApplicationLabel(app),
						onSendRejectionMessage: this.sendRejectionMessage(app),
						onLabelFormSubmit: this.addApplicationLabel(app),
						labelEditing: true,
						draggable: job.status !== 'Closed',
						removable: this.props.backOffice && app.state === 'interested',
						backOffice: this.props.backOffice,
						onRemove: this.onCardRemove,
						isAssigned:
							app.state === JobApplicationState.TO_INTERVIEW &&
							this.isCandidateAssigned(app.candidate.id, slots),
						// onAddReport: this.onAddReport,
						onEditApplication: this.onEditApplication,
						onShowOffer: this.onShowOffer,
						possibleDestinations: JobApplicationStateMachine[app.state],
						moveCard: (cardId, srcLaneId, dstLaneId, position) => {
							const result = this.handleDragEnd(cardId, srcLaneId, dstLaneId, position, card);
							if (result) {
								this.boardEventBus.publish({
									type: 'MOVE_CARD',
									fromLaneId: srcLaneId,
									toLaneId: dstLaneId,
									cardId: cardId
								});
								this.updateCardStateAndRefreshBoard(cardId, dstLaneId);
							}
						}
					};
					data[app.state].cards.push(card);
				});

				this.handleCompanySearch(job.company.name);
				this.handleCompanySelect(job.company.id, job.id);
				this.setState(
					{
						selectedJob: job,
						data: { lanes: Object.values(data) },
						loading: false,
						selectedJobSlots: slots
						// selectedCompany: job.company.id
					},
					() => this.updateLanesLabels()
				);
				return { lanes: Object.values(data) };
			}
		} catch (err: any) {
			notifyError(err.message);
			this.setState({ loading: false });
		}
		return;
	};

	handleJobSelect = val => {
		const filter = val ? { job: val } : {};
		const qs = new URLSearchParams(location.search);
		this.props.navigate({
			pathname: this.props.location.pathname,
			search: objectToSearchParams({
				...filter,
				...this.state.jobsFilter,
				...this.state.companiesFilter,
				applicant: qs.get('applicant')
			})
		});
		if (!val) {
			this.setState({
				selectedJob: null
			});
		}
	};

	handleCompanySearch = value => {
		this.searchCompanies$.next({ filter: { name: value } });
		// this.props.navigate(objectToSearchParams({ companyName: value }));
	};
	handleJobSearch = (e, key) => {
		let value;
		if (e && e.target && e.target.value !== undefined) value = e.target.value;
		else value = e;
		if (value === '') value = undefined;
		const filter = { ...this.state.jobsFilter };
		filter[key] = value;
		// this.props.navigate(
		// 	objectToSearchParams({
		// 		...filter,
		// 		...this.state.jobsFilter,
		// 		...this.state.companiesFilter,
		// 		job: this.selectJob?.id
		// 	})
		// );

		this.searchJobs$.next({ filter });
	};

	handleCompanySelect = (val, jobId?) => {
		const filter = val ? { companyId: val } : {};
		this.handleJobSearch(filter.companyId, 'companyId');
		const qs = new URLSearchParams(location.search);

		this.props.navigate({
			pathname: this.props.location.pathname,
			search: objectToSearchParams(
				cleanUndefined({
					...filter,
					...this.state.jobsFilter,
					...this.state.companiesFilter,
					job: jobId || undefined,
					applicant: qs.get('applicant')
				})
			)
		});
		this.setState({
			selectedCompany: val,
			loading: false,
			selectedJob: null
		});
	};

	removeApplicationLabel = application => async labelId => {
		const { id: cardId, state: laneId } = application;
		try {
			await jobsService.removeApplicationLabel(this.state.selectedJob.id, cardId, labelId);
		} catch (e: any) {
			notifyError(e.message);
			return;
		}
		this.changeCardState(laneId, cardId, card => {
			const labels = card.labels.filter(label => label.id !== labelId);
			return {
				...card,
				labels
			};
		});
	};

	sendRejectionMessage = application => async labelId => {
		try {
			await jobsService.sendRejectionMessage(application);
			notifySuccess('Email sent successfully');
		} catch (e: any) {
			notifyError(e.message);
			return;
		}
	};

	addApplicationLabel = application => async label => {
		const { id: cardId, state: laneId } = application;
		let resp;
		try {
			resp = await jobsService.addApplicationLabel(this.state.selectedJob.id, cardId, label);
		} catch (e: any) {
			notifyError(e.message);
			return;
		}
		this.changeCardState(laneId, cardId, card => {
			const labels = [...card.labels, resp];
			return {
				...card,
				labels
			};
		});
	};

	changeCardState(laneId, cardId, mutation) {
		const data = { ...this.state.data };
		data.lanes = data.lanes.map(lane => {
			if (lane.id === laneId) {
				lane = {
					...lane,
					cards: lane.cards.map(card => {
						if (card.id === cardId) {
							card = mutation(card);
						}
						return card;
					})
				};
			}
			return lane;
		});
		this.setState({ data });
	}

	changeCardStateLite(mutation) {
		const data = { ...this.state.data };
		data.lanes = data.lanes.map(lane => {
			lane = {
				...lane,
				cards: lane.cards.map(card => mutation(card))
			};
			return lane;
		});
		this.setState({ data });
	}

	showInterviewConfirmation = (onOk, onCancel) => {
		Modal.confirm({
			title: 'Are You Sure?',
			icon: <ExclamationCircleOutlined />,
			content: 'This action will decrease your permitted interviews by 1',
			okText: 'Yes',
			cancelText: 'No',
			onOk() {
				onOk();
			},
			onCancel() {
				onCancel();
				return false;
			}
		});
	};

	updateLanesLabels = () => {
		const data = { lanes: [...this.state.data.lanes] };
		this.state.data.lanes.forEach(lane => {
			data.lanes.find(l => l.id === lane.id).label = '' + lane.cards.length;
		});
		this.setState({ data });
	};

	updateCardStateAndRefreshBoard = (cardId, laneId) => {
		this.updateLanesLabels();
		this.changeCardState(laneId, cardId, card => ({
			...card,
			state: laneId
		}));
	};

	changeApplicationState = (card, srcLaneId, dstLaneId, srcPos, currentStep, stepsStatus) => {
		jobsService
			.changeApplicationState(card.id, {
				fromState: srcLaneId,
				toState: dstLaneId,
				currentStep,
				stepsStatus
			})
			.then(() => {
				notifySuccess(`Candidate "${card.candidate.code}" moved to ${dstLaneId} state successfully!`);
				if (dstLaneId === 'toInterview') {
					this.setState({
						stat: {
							...this.state.stat,
							spent: this.state.stat.spent + 1,
							permitted: this.state.stat.permitted - 1,
							percentage: Math.round(((this.state.stat.spent + 1) / this.state.stat.total) * 100)
						}
					});
					this.setState({ slotFormModalVisible: true });
				}
				this.updateCardStateAndRefreshBoard(card.id, dstLaneId);
				return true;
			})
			.catch(e => {
				notifyError(e.message);
				if (e.errorCode === ErrorCodes.ERR_NO_ENOUGH_SLOTS) {
					// this.setState({
					// 	addSlotsButtonAnimation: true
					// });
					// setTimeout(() => {
					// 	this.setState({ addSlotsButtonAnimation: false });
					// }, +this.state.addSlotsButtonAnimationDuration * 1000);
					this.setState({ slotFormModalVisible: true });
				}

				if (e.errorCode === ErrorCodes.ERR_NO_ENOUGH_PERMS) {
					this.setState({
						upgradeButtonAnimation: true
					});
					setTimeout(() => {
						this.setState({ upgradeButtonAnimation: false });
					}, +this.state.upgradeButtonAnimationDuration * 1000);
				}
				this.boardEventBus.publish({
					type: 'MOVE_CARD',
					fromLaneId: dstLaneId,
					toLaneId: srcLaneId,
					cardId: card.id,
					index: srcPos
				});
				return false;
			});
	};
	isCandidateAssigned = (candidateId, slots) => {
		if (slots && slots.length) {
			const assignedSlotsCandidates = slots.filter(slot => slot.candidate != null).map(slot => slot.candidate.id);
			return assignedSlotsCandidates.includes(candidateId);
		}
		return false;
	};

	handleDragEnd = (cardId, srcLaneId, dstLaneId, position, card) => {
		if (srcLaneId === dstLaneId) {
			return true;
		}
		if (!JobApplicationStateMachine[srcLaneId].includes(dstLaneId)) {
			notifyError(`Invalid state transition from ${srcLaneId} to ${dstLaneId}`);
			return false;
		}
		const originalPosition = this.state.data.lanes
			.find(l => l.id === srcLaneId)
			.cards.findIndex(c => c.id === cardId);
		return this.applicationStateMachine[dstLaneId](card, srcLaneId, originalPosition, position);
	};

	handleCardClick = async (cardId, metadata, laneId) => {
		const lane = this.state.data.lanes.find(lane => lane.id == laneId);
		if (!lane) return false;
		const card = lane.cards.find(card => card.id === cardId);
		this.setState({
			showCandidateView: true,
			selectedCard: card || null
		});
		return false;
	};

	onOfferOk = async offer => {
		let res;
		try {
			const fd = new FormData();
			Object.keys(offer).forEach(k => offer[k] && fd.append(k, offer[k]));
			fd.append('candidate', this.state.applicationToOffer.id);
			res = await jobsService.makeOffer(this.state.selectedJob.id, this.state.applicationToOffer.id, fd);
			if (!res) throw new Error(`Error while trying to make the offer`);
		} catch (e: any) {
			notifyError(e.message);
			this.boardEventBus.publish({
				type: 'MOVE_CARD',
				fromLaneId: this.state.applicationToOffer.to,
				toLaneId: this.state.applicationToOffer.from,
				cardId: this.state.applicationToOffer.id,
				index: this.state.applicationToOffer.index
			});
			return this.hideModal('showOfferForm')();
		}
		notifySuccess(`Offer made for candidate "${this.state.applicationToOffer.name}" successfully!`);
		this.updateCardStateAndRefreshBoard(this.state.applicationToOffer.id, 'offer');
		this.hideModal('showOfferForm')();
		this.setState({
			outsourceModalVisible: true
		});
	};

	onOfferCancel = () => {
		this.boardEventBus.publish({
			type: 'MOVE_CARD',
			fromLaneId: this.state.applicationToOffer.to,
			toLaneId: this.state.applicationToOffer.from,
			cardId: this.state.applicationToOffer.id,
			index: this.state.applicationToOffer.index
		});
		this.hideModal('showOfferForm')();
	};

	onRejectionOk = async reason => {
		const currentStep = applicationStateToStepMapper[this.state.applicationToReject.from];
		const stepsStatus = createStepsStatus(currentStep);
		stepsStatus[currentStep] = JobApplicationCompanyReviewState.FAILED;
		try {
			await jobsService.changeApplicationState(this.state.applicationToReject.id, {
				fromState: this.state.applicationToReject.from,
				toState: 'rejected',
				currentStep,
				stepsStatus,
				reason
			});
		} catch (e: any) {
			notifyError(e.message);
			this.boardEventBus.publish({
				type: 'MOVE_CARD',
				fromLaneId: this.state.applicationToReject.to,
				toLaneId: this.state.applicationToReject.from,
				cardId: this.state.applicationToReject.id,
				index: this.state.applicationToReject.index
			});
			return this.hideModal('showRejectionForm')();
		}
		notifySuccess(`Candidate "${this.state.applicationToReject.name}" is rejected.`);
		this.updateLanesLabels();
		this.changeCardState('rejected', this.state.applicationToReject.id, card => ({
			...card,
			application: { ...card.application, rejectionReason: reason, state: 'rejected' }
		}));
		this.hideModal('showRejectionForm')();
	};

	onRejectionCancel = () => {
		this.boardEventBus.publish({
			type: 'MOVE_CARD',
			fromLaneId: this.state.applicationToReject.to,
			toLaneId: this.state.applicationToReject.from,
			cardId: this.state.applicationToReject.id,
			index: this.state.applicationToReject.index
		});
		this.hideModal('showRejectionForm')();
	};
	onApplicationAssign = candidateId => {
		const cardId = this.state.data.lanes[1].cards.find(card => card.candidate.id === candidateId).id;
		this.changeCardState(JobApplicationState.TO_INTERVIEW, cardId, card => ({
			...card,
			isAssigned: true
		}));
	};

	syncBoardState = nextState => {
		this.setState({ data: nextState });
	};

	hideModal = state => () => {
		this.setState({
			[state]: false
		});
	};
	onNewSlotError = e => {
		//handle failure
		notifyError(e.message);
		this.setState({ slotFormModalVisible: false });
		return;
	};

	onNewSlotSuccess = (slot, extra = false) => {
		const slots = [...this.state.selectedJobSlots, slot];

		this.setState({
			slotFormModalVisible: extra,
			selectedJobSlots: slots
		});
		notifySuccess('Slot added successfully');
	};

	handleEditSlotSuccess = slot => {
		const oldSlots = [...this.state.selectedJobSlots];
		const newSlots = oldSlots.map(s => {
			if (slot.id === s.id) {
				return {
					...s,
					start: slot.appointment.from,
					end: slot.appointment.to,
					interviewer: slot.interviewer,
					location: slot.location,
					isOnline: slot.isOnline,
					notes: slot.notes
				};
			}
			return s;
		});
		this.setState({ selectedJobSlots: newSlots });
		notifySuccess('Slot edited successfully');
	};
	handleEditSlotError = () => {
		notifyError("Couldn't edit the interview slot");
	};

	boardEventBusHandle = handle => {
		this.boardEventBus = handle;
	};

	// onAddReport = application => {
	// 	this.setState({
	// 		selectedApplication: application,
	// 		addReportModalVisible: true
	// 	});
	// };

	// onAddApplicantReportSuccess = response => {
	// 	if (this.state.selectedApplication) this.state.selectedApplication.technicalReport = response.reportUrl;
	// 	this.hideModal('addReportModalVisible')();
	// 	notifySuccess('Report added Successfully');
	// };

	onCandidateViewModalCancel = () => {
		this.hideModal('showCandidateView')();
		this.setState({ selectedCard: null });
	};

	onCandidateUpdate = candidate => {
		const lanes = [...this.state.data.lanes];
		const lane = lanes.find(l => l.id === this.state.selectedCard.application.state);
		lane.cards = lane.cards.map(card => {
			if (card.candidate.id === candidate.id) {
				card = {
					...card,
					title: candidate.code,
					subtitle: candidate.title,
					candidate: {
						...this.state.selectedCard.candidate,
						...candidate
					}
				};
			}
			return card;
		});
		this.setState({
			data: { lanes },
			selectedCard: null,
			showCandidateFormModal: false
		});
		notifySuccess('Updated successfully!');
	};

	onApplicationEditSuccess = application => {
		notifySuccess('Application updated successfully');
		const lanes = [...this.state.data.lanes];
		const laneIndex = lanes.findIndex(lane => lane.id === application.state);
		const lane = lanes[laneIndex];
		lane.cards = lane.cards.map(card => {
			if (card.application.id === application.id) {
				card.application = application;
				card.currentSalary = application.currentSalary;
				card.expectedSalary = application.expectedSalary;
				card.noticePeriod = application.noticePeriod;
			}
			return card;
		});
		lanes[laneIndex] = lane;
		this.setState({ editApplicationModalVisible: false, data: { lanes }, selectedApplication: application });
	};

	onApplicationEditError = () => {
		notifyError("Couldn't Update the job application");
		this.setState({ editApplicationModalVisible: false });
		return;
	};

	hideOfferViewModal = () => {
		this.setState({
			showOfferView: false,
			selectedOffer: null
		});
	};

	changeOfferState = status => () => {
		this.setState({ offer: { ...this.state.selectedOffer, status } });
		this.hideOfferViewModal();
	};

	onCounterSuccess = counterOffer => {
		this.setState({
			offer: {
				...this.state.selectedOffer,
				counterOffers: [...this.state.selectedOffer.counterOffers, counterOffer]
			}
		});
		this.hideOfferViewModal();
	};
	render() {
		const theme = this.props.theme;
		const job = this.state.selectedJob;
		const selectedJobId = job && job.id;
		const jobTitle = job && job.title;
		const applicationToOfferName = this.state.applicationToOffer && this.state.applicationToOffer.name;
		const applicationToRejectName = this.state.applicationToReject && this.state.applicationToReject.name;
		return (
			<div className={`dashboard`} style={{ width: '98%' }}>
				<Row gutter={0} className="justify-content-between mx-auto mb-4">
					<Col xs={{ span: 24 }} className="text-start page-label">
						<SectionTitle>Job Board</SectionTitle>
					</Col>
				</Row>
				<Spin spinning={this.state.loading} style={{ height: '100%' }}>
					<Row gutter={0} className="px-1 mb-3">
						{this.props.backOffice ? (
							<Fragment>
								<Col xs={{ span: 24 }} md={{ span: 6, push: 11 }}>
									<TASelect
										onClear={() => this.searchCompanies$.next({ pageSize: 50 })}
										value={this.state.selectedCompany || undefined}
										onChange={e => this.handleCompanySelect(e)}
										placeholder="Select a company"
										style={{ width: '100%' }}
										className="ta-ant-input  mb-3 mb-lg-0"
										filterOption={(input, option) =>
											option.props.children[0].props.children
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
										}
										onSearch={this.handleCompanySearch}
										showSearch
									>
										{this.state.companies?.map(c => (
											<Select.Option value={c.id} key={c.id}>
												<span className="me-1">{c.name}</span>
												<Tooltip title={`${c.verified ? '' : 'un'}verified`}>
													{verificationMapper(theme)[c.joinStatus]}
												</Tooltip>
											</Select.Option>
										))}
									</TASelect>
								</Col>
								<Col xs={{ span: 24 }} md={{ span: 6, push: 12 }}>
									<TASelect
										ref={this.jobSelector}
										filterOption={(input, option) =>
											option.props.children[0].props.children
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
										}
										value={selectedJobId || undefined}
										onChange={this.handleJobSelect}
										placeholder="Select a job"
										style={{ width: '100%' }}
										className="ta-ant-input"
										onSearch={e => this.handleJobSearch(e, 'title')}
										showSearch
									>
										{this.state.selectedJob &&
											!this.state.jobs.find(job => job.id === this.state.selectedJob.id) && (
												<Option
													value={this.state.selectedJob.id}
													key={this.state.selectedJob.id}
												>
													<span className="me-2">{`${this.state.selectedJob.title} | ${this.state.selectedJob.company.name}`}</span>
													<Tag color={JobStatusMap[job.status]}>
														{this.state.selectedJob.status}
													</Tag>
												</Option>
											)}
										{this.state.jobs &&
											this.state.jobs
												.filter(job =>
													this.state.selectedCompany
														? job.company.id == this.state.selectedCompany
														: true
												)
												.map(job => (
													<Option value={job.id} key={job.id}>
														<span className="me-2">
															{`${job.title} | ${job.company.name}`}
														</span>
														<Tag color={JobStatusMap[job.status]}>{job.status}</Tag>
													</Option>
												))}
									</TASelect>
								</Col>
							</Fragment>
						) : (
							this.state.stat && (
								<Fragment>
									<Col
										className="mb-2"
										xs={{ span: 24, push: 0 }}
										md={{ span: 6, push: 0 }}
										lg={{ span: 6, push: 0 }}
									>
										<TASelect
											ref={this.jobSelector}
											value={selectedJobId || undefined}
											optionFilterProp="children"
											filterOption={(input, option) =>
												option.props.children[0].props.children
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											onChange={this.handleJobSelect}
											placeholder="Select a job"
											style={{ width: '100%' }}
											className="ta-ant-input"
											onSearch={this.handleJobSearch}
											showSearch
										>
											{this.state.jobs.map(job => (
												<Option value={job.id} key={job.id}>
													<span className="me-2">{job.title}</span>
													<Tag color={JobStatusMap[job.status]}>{job.status}</Tag>
												</Option>
											))}
										</TASelect>
									</Col>
									<Col
										className="mb-3 d-flex flex-column justify-content-center flex-sm-row align-items-center "
										xs={{ span: 24 }}
										md={{ span: 18, push: 1 }}
										lg={{ span: 15, push: 5 }}
									>
										<Col
											xs={{ span: 20 }}
											sm={{ span: 6, push: 0 }}
											md={{ span: 6, push: 0 }}
											lg={{ span: 6, push: 0 }}
											className="d-flex align-items-center justify-content-center mb-2"
										>
											<TeamOutlined
												style={{ fontSize: '1.3rem', color: '#9FA2B4' }}
												className="me-1"
											/>
											<span style={{ fontSize: '1rem', fontWeight: 700, color: '#18233D' }}>
												{this.state.stat.spent} Interviewed
											</span>
										</Col>
										{/* <Col
											xs={{ span: 20 }}
											sm={{ span: 10, push: 0 }}
											md={{ span: 10, push: 0 }}
											lg={{ span: 9, push: 0 }}
											className="mb-2"
										>
											<div className="mb-2 d-flex flex-column ">
												<span style={{ fontSize: '1rem', fontWeight: 700, color: '#9FA2B4' }}>
													<span style={{ color: '#18233D' }} className="me-1">
														{this.state.stat.total - this.state.stat.spent}
													</span>{' '}
													interviews left
												</span>
												<TAProgressBar percent={this.state.stat.percentage} />
											</div>
										</Col> */}
										{/* <Col
											xs={{ span: 24 }}
											sm={{ span: 7, push: 1 }}
											md={{ span: 7, push: 1 }}
											lg={{ span: 9, push: 1 }}
											className="text-center text-md-start"
										>
											<TAButton
												btntype={ButtonType.PRIMARY}
												// animation={upgradeButtonAnimation}
												// animationDuration={
												// upgradeButtonAnimation ? upgradeButtonAnimationDuration : undefined
												// }
												// height={40}
												// width={128}
												onClick={() => this.setState({ plansModalVisible: true })}
											>
												Upgrade
											</TAButton>
										</Col> */}
									</Col>
								</Fragment>
							)
						)}
					</Row>
					<Row gutter={16} className="px-1 mb-2">
						{!this.props.backOffice && (
							<Col
								className="d-flex justify-content-center mb-3"
								xs={{ span: 12, push: 0 }}
								sm={{ span: 4, push: 3 }}
								md={{ span: 4, push: 7 }}
								lg={{ span: 4, push: 16 }}
							>
								<Tooltip
									title={
										!this.state.selectedJob || this.state.selectedJob.status === 'Closed'
											? 'You have to select a non-closed job'
											: ''
									}
								>
									<TAButton
										btntype={
											!this.state.selectedJob || this.state.selectedJob.status === 'Closed'
												? ButtonType.GHOST
												: ButtonType.PRIMARY
										}
										// animation={addSlotsButtonAnimation}
										// animationDuration={
										// 	addSlotsButtonAnimation ? addSlotsButtonAnimationDuration : undefined
										// }
										onClick={() => this.setState({ slotFormModalVisible: true })}
										className="d-flex align-items-center"
										// height={44}
										disabled={!this.state.selectedJob || this.state.selectedJob.status === 'Closed'}
									>
										<PlusOutlined />
										<span style={{ fontWeight: 500 }}>Add Interview Slots</span>
									</TAButton>
								</Tooltip>
							</Col>
						)}
						<Col
							className="d-flex justify-content-center mb-3"
							xs={{ span: 12, push: 0 }}
							sm={{ span: 4, push: 6 }}
							md={{ span: 4, push: 9 }}
							lg={{ span: 4, push: 16 }}
						>
							<Tooltip
								title={
									!this.state.selectedJob || this.state.selectedJob.status === 'Closed'
										? 'You have to select a non-closed job'
										: ''
								}
							>
								<TAButton
									onClick={() => {
										this.setState({ slotsViewModalVisible: true });
									}}
									className="d-flex align-items-center"
									btntype={
										!this.state.selectedJob || this.state.selectedJob.status === 'Closed'
											? ButtonType.GHOST
											: ButtonType.PRIMARY
									}
									// height={44}
									disabled={!this.state.selectedJob || this.state.selectedJob.status === 'Closed'}
								>
									<CalendarOutlined />
									<span style={{ fontWeight: 500 }}>View Interview Slots</span>
								</TAButton>
							</Tooltip>
						</Col>
					</Row>

					<div className="dashboard-content v-scroll mb-3" style={{ height: '72vh' }}>
						{this.state.selectedJob ? (
							<Fragment>
								{this.state.applicationToOffer && (
									<JobOfferModalForm
										headerTitle={`Job Offer to ${applicationToOfferName} for ${jobTitle} vacancy at ${job.company.name}`}
										onOk={this.onOfferOk}
										onCancel={this.onOfferCancel}
										visible={this.state.showOfferForm}
									/>
								)}

								{this.state.applicationToReject && (
									<JobRejectionModalForm
										headerTitle={`Reject candiadte ${applicationToRejectName} for ${jobTitle} vacancy`}
										onOk={this.onRejectionOk}
										onCancel={this.onRejectionCancel}
										visible={this.state.showRejectionForm}
										options={RejectionReasons}
										showOther
									/>
								)}

								{this.state.selectedCard ? (
									<CandidateViewModal
										onCancel={this.onCandidateViewModalCancel}
										visible={this.state.showCandidateView}
										candidate={this.state.selectedCard.candidate}
										application={this.state.selectedCard.application}
										job={this.state.selectedJob}
										avatarBgColor={this.state.selectedCard.bgColor}
										minimal={!this.props.backOffice}
										onEdit={this.onEditApplication}
										copyable
										showCustomReports={false}
										showComments
										showAvatar={!!this.props.backOffice}
										reportAddable
										candidateEditable={!!this.props.backOffice}
										commentsSort={this.props.backOffice ? 'desc' : 'asc'}
										showStateChangeLog
									/>
								) : null}
								{/* {this.props.backOffice && this.state.addReportModalVisible ? (
									<AddReportModal
										onCancel={() => {
											this.hideModal('addReportModalVisible')();
										}}
										visible={this.state.addReportModalVisible}
										candidate={this.state.selectedApplication.candidate}
										applicationId={this.state.selectedApplication.id}
										job={this.state.selectedJob}
										onOk={this.onAddApplicantReportSuccess}
									/>
								) : null} */}

								{this.props.backOffice && this.state.editApplicationModalVisible ? (
									<RecommendCandidateModal
										visible={this.state.editApplicationModalVisible}
										candidate={this.state.selectedApplication.candidate}
										job={this.state.selectedJob}
										application={this.state.selectedApplication}
										onEditSuccess={this.onApplicationEditSuccess}
										onError={this.onApplicationEditError}
										onCancel={() =>
											this.setState({
												editApplicationModalVisible: false
											})
										}
									/>
								) : null}
								{/* {this.props.backOffice &&
								this.state.selectedCard &&
								this.state.showCandidateFormModal ? (
									<CandidateModalForm
										visible={this.state.showCandidateFormModal}
										candidate={this.state.selectedCard.candidate}
										onCancel={() => this.setState({ showCandidateFormModal: false })}
										onUpdateSuccess={this.onCandidateUpdate}
									/>
								) : null} */}

								<OutsourcingModal
									open={this.state.outsourceModalVisible}
									onCancel={() => {
										this.setState({ outsourceModalVisible: false });
									}}
								/>

								<Board
									data={this.state.data}
									laneDraggable={true}
									cardDraggable={this.state.selectedJob.status === 'Closed' ? false : true}
									style={boardStyle}
									laneStyle={laneStyle}
									handleDragEnd={this.handleDragEnd}
									onCardClick={this.handleCardClick}
									hideCardDeleteIcon={true}
									eventBusHandle={this.boardEventBusHandle}
									onDataChange={this.syncBoardState}
									components={{ Card: CandidateCard }}
								/>
							</Fragment>
						) : (
							<h3 className="text-center mt-3">Select a Job Post</h3>
						)}
					</div>
				</Spin>

				<Modal
					footer={null}
					style={{ minWidth: '70%' }}
					visible={this.state.plansModalVisible}
					onCancel={() => this.setState({ plansModalVisible: false })}
				>
					<Row className="mb-3">
						<span style={{ fontSize: '1.5rem', fontWeight: '700', color: '#000' }}>Add Interviews</span>
					</Row>
					<Row className="d-flex align-items-center ">
						<Col xs={24} md={12}>
							<PackagesBox mode="vertical" />
						</Col>
						<Col xs={24} md={12} className="text-end d-none d-md-block">
							<img className="w-100" src={plansImage} />
						</Col>
					</Row>
				</Modal>
				<>
					{!this.props.backOffice && this.state.slotFormModalVisible && (
						<InterviewSlotFormModal
							job={this.state.selectedJob}
							jobs={this.state.jobs}
							onCreateSlotSuccess={this.onNewSlotSuccess}
							onSlotFormCancel={() => this.setState({ slotFormModalVisible: false })}
							onCreateSlotError={this.onNewSlotError}
							visible={this.state.slotFormModalVisible}
							allowExtraSlot={true}
						/>
					)}
					<InterviewSlotsViewModal
						selectedJob={this.state.selectedJob}
						jobs={this.state.jobs}
						interviewSlots={this.state.selectedJobSlots}
						onCancel={() => this.setState({ slotsViewModalVisible: false })}
						visible={this.state.slotsViewModalVisible}
						backOffice={this.props.backOffice}
						onSloteCreate={() => {
							this.setState({ slotFormModalVisible: true });
						}}
						onSchedule={this.onApplicationAssign}
						onEditSlotSuccess={this.handleEditSlotSuccess}
						onEditSlotError={this.handleEditSlotError}
					/>
					{this.state.selectedOffer ? (
						<JobOfferViewModal
							visible={this.state.showOfferView}
							offer={this.state.selectedOffer}
							job={this.state.selectedJob}
							company={this.state.selectedJob.company}
							onCancel={this.hideOfferViewModal}
							onWithdraw={this.changeOfferState(JobOfferStatus.WITHDRAWN)}
							onAccept={this.changeOfferState(JobOfferStatus.ACCEPTED)}
							onReject={this.changeOfferState(JobOfferStatus.REJECTED)}
							onCounter={this.onCounterSuccess}
							backOffice={this.props.backOffice}
						/>
					) : null}
				</>
			</div>
		);
	}
}
export default withRouter(JobBoard);
